export enum ErrorType {
  Default,
  CantGenerateOffer,
  CantGetStatementFile,
  InvalidMethodAuthentication,
  CantGenerateCardApplication,
  CantJoinCardWaitlist,
  CantSetUpPayrollDeduction,
}

export enum ErrorParam {
  StatementFile = '__statement_file',
}
